var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oilslist"},[_c('oils-list',{attrs:{"allOrder":2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }